import { lazy, Suspense } from "react";
import { useMediaQuery } from "@/hooks/use-media-query";

const DesktopPage = lazy(() => import("../desktop/desktop-page"));
const MobilePage = lazy(() => import("../mobile/mobile-page"));

export default function ViewRenderer() {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  return (
    <Suspense fallback={<div className="h-full w-full" aria-hidden="true" />}>
      {isDesktop ? <DesktopPage /> : <MobilePage />}
    </Suspense>
  );
}
